// extracted by mini-css-extract-plugin
export default {"button":"al-z","reviewSort":"bl-z"};